import React from "react";

const BarChart2Line = () => (
	<g>
		<path d='M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z'></path>
	</g>
);

export default BarChart2Line;
